export interface ICreatorIdentifierProps {
  name: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a tax in badge format
 */
export function CreatorIdentifier({ name }: Readonly<ICreatorIdentifierProps>) {
  return (
    <div
      className="
        inline-block rounded-full border bg-gray-100 px-2 py-1.5
        text-xs text-gray-700
      "
    >
      {name}
    </div>
  );
}
